module.exports = __webpack_public_path__ + "img/horizontal_6_1_pp1_5012.640b0d6c.png";